  const rootElement = document.querySelector('#shopify-section-hb-lp-calculator-new')
  const { devices } = JSON.parse(rootElement.dataset.propsJson)

  const deviceButtonElements = Array.from(rootElement.querySelectorAll('[data-selector="device-button"]'))
  const monthButtonElements = Array.from(rootElement.querySelectorAll('[data-selector="month-button"]'))

  const btcPriceButtonElements = Array.from(rootElement.querySelectorAll('[data-selector="btc-price-button"]'))

  const btcPriceButtonsUsed = btcPriceButtonElements.length > 0

  const priceInputElement = rootElement.querySelector('[data-selector="price-input"]')
  const priceButtonElements = Array.from(rootElement.querySelectorAll('[data-selector="price-button"]'))

  const yearlyIncomeUsdElement = rootElement.querySelector('[data-selector="yearly-income-usd"]')
  const yearlyIncomeSatElement = rootElement.querySelector('[data-selector="yearly-income-sat"]')
  const cashbackElements = Array.from(rootElement.querySelectorAll('[data-selector="cashback"]'))

  const addToCartButtonElement = rootElement.querySelector('[data-selector="add-to-cart-button"]')

  fetch('https://api.heatbit.com/api/v2.0/currency/rates')
  .then((res) => res.json())
  .then((data) => {
    const { btcPrice, hashValue } = data.body

    const calculateAndUpdateDOM = () => {
      const day = 30.5
      const activeDeviceBtn = deviceButtonElements.find(el => el.dataset.active === 'true')
      const selectedDevice = devices.find(device => device.label === activeDeviceBtn.dataset.value)
      
      const th = selectedDevice.th
      const wh = selectedDevice.wh
      const deviceNumber = 1
      
      const activeMonthBtn = monthButtonElements.find(el => el.dataset.active === 'true')
      const monthNumber = Number(activeMonthBtn.dataset.value)

      const electricityPriceKwh = priceInputElement.dataset.active === "true"
        ? Number(priceInputElement.dataset.value)
        : Number(priceButtonElements.find(el => el.dataset.active === 'true').dataset.value)

      let activeBtcPrice = btcPrice
      if (btcPriceButtonsUsed) {
        const activeBtcPriceBtn = btcPriceButtonElements.find(el => el.dataset.active === 'true')
        const btcPriceFromBtn = Number(activeBtcPriceBtn.dataset.value)
        activeBtcPrice = btcPriceFromBtn
      }

      const yearlyIncomeUsd = Math.round(activeBtcPrice * hashValue * th * day * monthNumber * deviceNumber)
      const yearlyIncomeSat = Math.floor(100_000_000 * hashValue * th * day * monthNumber * deviceNumber)
      const costOfRunning = (wh * electricityPriceKwh / 1000) * 24 * day * monthNumber * deviceNumber

      yearlyIncomeUsdElement.innerText = yearlyIncomeUsd
      yearlyIncomeSatElement.innerText = yearlyIncomeSat.toLocaleString()

      const cashback = (yearlyIncomeUsd / costOfRunning * 100)
      const cashbackValid = Number.isFinite(cashback) && costOfRunning > 0

      cashbackElements.forEach(cashbackElement => {
        if (!cashbackValid) {
          cashbackElement.className = 'tw:max-md:text-[1.875rem] tw:font-bold md:font-new-maximanrope-semibold--2430'
          cashbackElement.innerText = '—'
        } else {
          cashbackElement.className = 'tw:max-md:text-[1.875rem] tw:max-md:leading-[1.2] tw:max-md:font-bold md:font-new-maximanrope-semibold--4890'
          cashbackElement.innerText = `${cashback.toFixed(1)}%`
        }
      })
    }

    calculateAndUpdateDOM()

    deviceButtonElements.forEach(btn => btn.addEventListener('click', () => {
      deviceButtonElements.forEach(el => el.dataset.active = "false")
      btn.dataset.active = "true"
      calculateAndUpdateDOM()
    }))

    btcPriceButtonElements.forEach(btn => btn.addEventListener('click', () => {
      btcPriceButtonElements.forEach(el => el.dataset.active = "false")
      btn.dataset.active = "true"
      calculateAndUpdateDOM()
    }))

    btcPriceButtonElements[0].dataset.value = btcPrice
    btcPriceButtonElements[0].innerText = `Current - $${btcPrice.toLocaleString()}`

    monthButtonElements.forEach(btn => btn.addEventListener('click', () => {
      monthButtonElements.forEach(el => el.dataset.active = "false")
      btn.dataset.active = "true"
      calculateAndUpdateDOM()
    }))

    priceInputElement.addEventListener('focus', () => {
      priceButtonElements.forEach(btn => btn.dataset.active = "false")
      priceInputElement.dataset.active = "true"
    })

    priceInputElement.addEventListener('input', (e) => {
      priceInputElement.value = e.target.value.replace(/[^0-9.,]/g, '').replace(',', '.')
      priceInputElement.dataset.value = priceInputElement.value
      calculateAndUpdateDOM()
    })

    priceButtonElements.forEach(btn => btn.addEventListener('click', () => {
      priceInputElement.dataset.active = "false"
      priceInputElement.value = ""
      priceButtonElements.forEach(el => el.dataset.active = "false")
      btn.dataset.active = "true"
      calculateAndUpdateDOM()
    }))

    addToCartButtonElement.addEventListener('click', (e) => {
      e.preventDefault()
      const activeDeviceBtn = deviceButtonElements.find(el => el.dataset.active === 'true')
      const selectedDevice = devices.find(d => d.label === activeDeviceBtn.dataset.value)
      
      addToCartButtonElement.innerText = "Adding..."

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: selectedDevice.productVariantId, quantity: 1 }]
        })
      })
      .then(res => res.json())
      .then(() => {
        addToCartButtonElement.innerText = "Add to cart"
        if (typeof openIACartDrawer === 'function') openIACartDrawer()
      })
      .catch(err => console.error(err))
    })
  })
